/** Text stores produce for the UI: notices, errors, default names and activity labels. */
export default {
  connectedTitle: "Connected",
  connectedDescription: "{app} is now connected.",
  connectionFailedTitle: "{app} connection failed",
  oauthWindowFailed: "Could not open OAuth window: {reason}",
  connectionTimedOut: "Connection timed out after 5 minutes.",
  connectionExpired: "Connection expired. Please reconnect.",
  connectionFailed: "Connection failed. Please try again.",
  noActiveProject: "No active project",
  caughtUpTitle: "You're all caught up",
  caughtUpDescription: "Nothing to review.",
  loadFailed: "Failed to load",
  statusChangeFailed: "Could not change status",
  notificationsLoadFailed: "Couldn’t load notifications. Try again.",
  memoryLoadFailed: "Could not load memory.",
  projectsLoadFailed: "Failed to load projects",
  defaultProject: "Default Project",
  untitledProject: "Untitled Project",
  sentMessage: "Sent a message",
} as const;
